import React, { useState } from "react";
import { Button, FloatButton, Modal, Table, Tag } from "antd";

const TaskModal = ({ title, onCancel, data_tasks }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    onCancel?.();
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 50,
      fixed: "left",
    },
    {
      title: "Team Name",
      dataIndex: "team_name",
      key: "team_name",
      width: 150,
      fixed: "left",
    },
    {
      title: "Start Time",
      dataIndex: "start_at",
      key: "start_at",
      width: 180,
    },
    {
      title: "End Time",
      dataIndex: "due_at",
      key: "due_at",
      width: 180,
    },
    {
      title: "Members",
      dataIndex: "members",
      key: "members",
      render: (members) => (
        <div style={{ maxWidth: 200 }}>
          {members.map((member, index) => (
            <Tag key={index} color={member.is_manager ? "blue" : "default"}>
              {member.name}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "Managers",
      dataIndex: "managers",
      key: "managers",
      render: (managers) => (
        <div>
          {managers.map((manager, index) => (
            <Tag key={index} color="blue">
              {manager.name}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "Task Status",
      dataIndex: "task_status",
      key: "task_status",
      render: (status) => (
        <Tag color={getStatusColor(status?.name)}>
          {status?.name || "No status"}
        </Tag>
      ),
      width: 120,
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "UAT":
        return "orange";
      case "Completed":
        return "green";
      case "In Progress":
        return "blue";
      default:
        return "gray";
    }
  };

  const processDataSource = (tasks) => {
    if (!tasks || !Array.isArray(tasks)) return [];

    return tasks.map((item, index) => ({
      key: index + 1,
      team_name: item.team?.name || "No team",
      start_at: item.team_start_at || "Not started",
      due_at: item.team_due_at || "No deadline",
      members: item.members || [],
      managers: (item.members || []).filter((m) => m.is_manager),
      task_status: item.task_status_name || null,
    }));
  };

  const dataSource = processDataSource(data_tasks);

  return (
    <>
      <FloatButton
        description="Task Statuses"
        shape="square"
        onClick={showModal}
        style={{
          zIndex: 99999,
          bottom: "auto",
          right: 25,
          top: 10,
        }}
      />
      <Modal
        title={title}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Close
          </Button>,
        ]}
        width={1200}
      >
        {data_tasks ? (
          <Table
            className="feddback-table"
            columns={columns}
            dataSource={dataSource}
            scroll={{ x: true }}
            bordered
            pagination={{
              pageSize: 10,
              showSizeChanger: false,
            }}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </>
  );
};

export default TaskModal;
